import { render, staticRenderFns } from "./goFlexLineManagerTeamRequests.vue?vue&type=template&id=4f6a4bed"
import script from "./goFlexLineManagerTeamRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./goFlexLineManagerTeamRequests.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports